import React from 'react';
import './ToggleSwitch.css';
import LockIcon from '../svgIcons/LockUnlockIcon/LockIcon';

export interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    width?: number;
    disabled?: boolean;
    loading?: boolean;
    marginLeft?: number;
}

const ToggleSwitch = ({
    checked,
    onChange,
    disabled,
    marginLeft = 0,
    loading = false
}: ToggleSwitchProps) => {
    return (
        <div className="checkbox" style={{ marginLeft: marginLeft }}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled || loading}
            />
            <span className="icon">{<LockIcon loading={loading} locked={!checked} width={24} height={24} />}</span>
        </div>
    );
};

export default ToggleSwitch;
